import { render, staticRenderFns } from "./DashboardV3.vue?vue&type=template&id=65bc1ce3&scoped=true&"
import script from "./DashboardV3.vue?vue&type=script&lang=js&"
export * from "./DashboardV3.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV3.vue?vue&type=style&index=0&id=65bc1ce3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc1ce3",
  null
  
)

export default component.exports